export const NON_RECURRING_PROPOSAL_EXISTS = 'non-recurring-proposal-exists';
